import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GraphModule } from '../../graph/graph.module';
import { ListDisplayGraphModule } from '../../lists/list-display/list-display-graph/list-display-graph.module';
import { GraphDetailContentComponent } from './graph-detail-content.component';

@NgModule({
  declarations: [GraphDetailContentComponent],
  imports: [GraphModule, ListDisplayGraphModule, CommonModule],
  exports: [GraphDetailContentComponent],
})
export class GraphDetailContentModule {}
